import { SxProps, Theme } from '@mui/material/styles';
import { Box, styled as muiStyled } from '@mui/material';

export const tableCellStyles: React.CSSProperties = {
  border: '1px solid #E7EEF6',
  whiteSpace: 'nowrap',
  padding: '10px',
  fontSize: '1.4rem',
  color: '#224063',
};

export const PaginationBox = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 16,
  paddingBottom: 16,
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
  backgroundColor: '#fff',
}));

export const TablePaginationContainer = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  alignItems: 'center',
  gap: '24px',
  paddingLeft: '70%',
}));

export const paginationLabelStyles: SxProps<Theme> = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#1B2433',
  verticalAlign: 'middle',
  marginRight: '12px',
};
export const paginationSelectStyles: SxProps<Theme> = {
  '.MuiSelect-select': {
    padding: '6px 4px 6px 8px',
    backgroundColor: '#fff',
    border: '1px solid #E7EEF6',
    borderRadius: '2px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '0px',
    verticalAlign: 'middle',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    alignItems: 'center',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '.MuiSelect-icon': {
    right: '2px',
  },
  minWidth: '60px',
};

export const paginationNavigationStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0,
};

export const paginationCountStyles: SxProps<Theme> = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#224063',
  verticalAlign: 'middle',
  marginRight: '16px',
};

export const paginationArrowButtonStyles: SxProps<Theme> = {
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: '#E7EEF6',
  },
};

export const rowsPerPageContainerStyles: SxProps<Theme> = {
  mr: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const TableContainerWrapper = muiStyled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const searchTextFieldStyles: SxProps<Theme> = {
  minWidth: 400,
  width: '731px',
  height: '32px',
  borderRadius: '4px',
  border: '1px solid',
  borderColor: '#B7C1CC',
  mt: '3.2rem',
  mb: '2.4rem',
  maxWidth: '55%',
  '& .MuiOutlinedInput-input': {
    paddingY: '0.6rem',
  },
  '& .MuiOutlinedInput-root ': {
    paddingLeft: '0.8rem',
  },
  '& .MuiInputBase-root': {
    fontSize: '1.4rem',
  },
  '& input::placeholder': {
    fontSize: '1.4rem',
    lineHeight: 'normal',
  },
  '& fieldset': {
    border: '0.1rem solid #B7C1CC',
    borderRadius: '0.4rem',
  },
};

export const tableRowStyles: SxProps<Theme> = {
  '&:last-child td, &:last-child th': {
    border: '1px solid #E7EEF6',
  },
};

export const assigneeCellBoxStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  background: '#F5F8FB',
  borderRadius: '10px',
  padding: '6px 18px 6px 10px',
  minWidth: '150px',
  height: '48px',
  border: 'none',
  boxShadow: 'none',
};

export const assigneeSelectStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  background: '#F5F8FB',
  borderRadius: '10px',
  padding: '6px 10px',
  minWidth: '120px',
  height: '36px',
  cursor: 'pointer',
  '& .MuiSelect-select': {
    padding: 0,
  },
};

export const assigneeAvatarStyles: SxProps<Theme> = {
  width: 24,
  height: 24,
};

export const tableHeaderText: SxProps<Theme> = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#224063',
};
